module.exports = __webpack_public_path__ + "img/DXNEXTPAY.b97cb492.svg";